import { render, staticRenderFns } from "./BoardDashboard.vue?vue&type=template&id=232bae28&scoped=true&"
import script from "./BoardDashboard.vue?vue&type=script&lang=js&"
export * from "./BoardDashboard.vue?vue&type=script&lang=js&"
import style0 from "./BoardDashboard.vue?vue&type=style&index=0&id=232bae28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232bae28",
  null
  
)

export default component.exports